export const FIELD_COMMENT_MAX_LENGTH = 500;

export interface FieldCommentResponse {
  id: string;
  fieldPath: string;
  comment?: string | null;
  needsReview: boolean;
  manuallyEdited: boolean;
  isBenchmarkField: boolean;
  isValidated: boolean;
  aiOriginalValue?: string | null;
}

export interface CreateFieldCommentRequest {
  fieldPath: string;
  comment?: string | null;
  needsReview?: boolean;
  manuallyEdited?: boolean;
  isBenchmarkField?: boolean;
  isValidated?: boolean;
  aiOriginalValue?: string;
}

export interface UpdateFieldCommentRequest {
  comment?: string | null;
  needsReview?: boolean;
  manuallyEdited?: boolean;
  isBenchmarkField?: boolean;
  isValidated?: boolean;
  aiOriginalValue?: string;
}

export interface BenefitPlanFieldCommentsRequest {
  benefitPlanId: string;
  fields: CreateFieldCommentRequest[];
}

export interface UpsertFieldCommentsRequest {
  benefitPlans: BenefitPlanFieldCommentsRequest[];
}

export interface BenefitPlanFieldCommentsResponse {
  benefitPlanId: string;
  fieldComments: FieldCommentResponse[];
}

export interface UpsertFieldCommentsResponse {
  benefitPlans: BenefitPlanFieldCommentsResponse[];
}
